export const reqError = (req) => {
  const error_data = req?.response?.data?.error_data

  const errors = []

  if (error_data) {
    Object.keys(error_data).forEach((key) => {
      if (error_data[key]?.length) {
        error_data[key]?.forEach((error) => {
          errors.push(error || '')
        })
      }
    })
  }

  return {
    success: false,
    error: req?.response?.data?.message || 'Error',
    errors: errors?.length ? errors : null
  }
}

export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})
